import { fmtDateTime } from "@/lib/format";
import { STATUS_STYLES, COLOR_CLASSES } from "@/lib/format";
import { MessageSquare, Bell, RefreshCw, FileEdit, CircleDot } from "lucide-react";

const TYPE_ICON = { comment: MessageSquare, reminder: Bell, modification: FileEdit, status: CircleDot, update: RefreshCw, confirmation: CircleDot, system: CircleDot };

export default function POTimeline({ events }) {
  if (!events?.length) return <p className="text-sm text-muted-foreground p-4">No activity yet.</p>;
  return (
    <div data-testid="po-timeline" className="relative pl-6">
      <div className="absolute left-[9px] top-2 bottom-2 w-0.5 bg-slate-200" />
      <div className="space-y-5">
        {events.map((e, i) => {
          const color = e.status && STATUS_STYLES[e.status] ? STATUS_STYLES[e.status].color : "slate";
          const dot = COLOR_CLASSES[color]?.dot || "bg-slate-400";
          const Icon = TYPE_ICON[e.type] || CircleDot;
          return (
            <div key={e.id} data-testid={`timeline-event-${i}`} className="relative animate-fade-up" style={{ animationDelay: `${Math.min(i, 10) * 40}ms` }}>
              <span className={`absolute -left-6 top-1 flex h-[18px] w-[18px] items-center justify-center rounded-full border-2 border-white ${dot}`}>
                <Icon className="h-2.5 w-2.5 text-white" />
              </span>
              <p className="text-sm font-medium leading-snug">{e.message}</p>
              <p className="mt-0.5 text-xs text-muted-foreground">
                <span className="font-mono">{fmtDateTime(e.created_at)}</span>
                {" · "}{e.actor_name}
                {e.actor_role && e.actor_role !== "system" && <span className="capitalize"> ({e.actor_role})</span>}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
